import { render, staticRenderFns } from "./acatsLoginPage.vue?vue&type=template&id=708c0d79&"
import script from "./acatsLoginPage.vue?vue&type=script&lang=js&"
export * from "./acatsLoginPage.vue?vue&type=script&lang=js&"
import style0 from "./acatsLoginPage.vue?vue&type=style&index=0&id=708c0d79&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports